module.exports = __webpack_public_path__ + "static/media/ppetrovics.5942e8b2.jpg";